import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../authentication/AuthProvider";
import { routes } from "../routes/routes";
import { findCurrectPermission } from "../helpers/roles-and-permissions";
import { enums } from "../enums/Enums";

export function DocumentManagementAllDocsGuard() {
  let location = useLocation();
  const auth = useAuth();

  return auth?.user &&
    findCurrectPermission(enums.UserPermissionNames.DOCUMENTS_ALL) ? (
    <Outlet />
  ) : (
    <Navigate
      to={routes?.unAuthorized.match}
      state={{ from: location }}
      replace
    />
  );
}

export function DocumentManagementNewECNGuard() {
  let location = useLocation();
  const auth = useAuth();

  return auth?.user &&
    findCurrectPermission(
      enums.UserPermissionNames.DOCUMENTS_CREATE_NEW_ECN
    ) ? (
    <Outlet />
  ) : (
    <Navigate
      to={routes?.unAuthorized.match}
      state={{ from: location }}
      replace
    />
  );
}
export function DocumentManagementNewFCDGuard() {
  let location = useLocation();
  const auth = useAuth();

  return auth?.user &&
    findCurrectPermission(
      enums.UserPermissionNames.DOCUMENTS_CREATE_NEW_FCD
    ) ? (
    <Outlet />
  ) : (
    <Navigate
      to={routes?.unAuthorized.match}
      state={{ from: location }}
      replace
    />
  );
}

export function DocumentManagementNewLITGuard() {
  let location = useLocation();
  const auth = useAuth();

  return auth?.user &&
    findCurrectPermission(
      enums.UserPermissionNames.DOCUMENTS_CREATE_NEW_LIT
    ) ? (
    <Outlet />
  ) : (
    <Navigate
      to={routes?.unAuthorized.match}
      state={{ from: location }}
      replace
    />
  );
}

export function DocumentManagementNewSOPGuard() {
  let location = useLocation();
  const auth = useAuth();

  return auth?.user &&
    findCurrectPermission(
      enums.UserPermissionNames.DOCUMENTS_CREATE_NEW_SOP
    ) ? (
    <Outlet />
  ) : (
    <Navigate
      to={routes?.unAuthorized.match}
      state={{ from: location }}
      replace
    />
  );
}
export function DocumentManagementNewWIGuard() {
  let location = useLocation();
  const auth = useAuth();

  return auth?.user &&
    findCurrectPermission(enums.UserPermissionNames.DOCUMENTS_CREATE_NEW_WI) ? (
    <Outlet />
  ) : (
    <Navigate
      to={routes?.unAuthorized.match}
      state={{ from: location }}
      replace
    />
  );
}

export function DocumentManagementApprovalGuard() {
  let location = useLocation();
  const auth = useAuth();

  return auth?.user &&
    findCurrectPermission(
      enums.UserPermissionNames.DOCUMENTS_AWAITING_MY_APPROVAL
    ) ? (
    <Outlet />
  ) : (
    <Navigate
      to={routes?.unAuthorized.match}
      state={{ from: location }}
      replace
    />
  );
}
